import { render, staticRenderFns } from "./TicketForm.vue?vue&type=template&id=c2918224&scoped=true"
import script from "./TicketForm.vue?vue&type=script&lang=js"
export * from "./TicketForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2918224",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2918224')) {
      api.createRecord('c2918224', component.options)
    } else {
      api.reload('c2918224', component.options)
    }
    module.hot.accept("./TicketForm.vue?vue&type=template&id=c2918224&scoped=true", function () {
      api.rerender('c2918224', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ticketManager/TicketForm.vue"
export default component.exports